<ng-container *ngIf="paperLayout">
  <div class="mt-tuning-body">
    <div class="mt-tuning-group" *ngIf="performanceItems().length">
      <div class="mt-tuning-head mt-tuning-head--perf">
        <span class="mt-tuning-ico" aria-hidden="true">
          <svg width="8" height="8" viewBox="0 0 24 24" fill="#7C5CFC" stroke="#7C5CFC" stroke-width="2">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
          </svg>
        </span>
        <span class="mt-tuning-label">PERFORMANCE</span>
        <span class="mt-tuning-rule"></span>
      </div>
      <div class="mt-tuning-grid">
        <div
          *ngFor="let option of performanceItems()"
          class="mt-tune-row"
          [class.mt-tune-row--on]="option.value"
        >
          <div class="mt-tune-row-left">
            <span class="mt-tune-dot" *ngIf="option.value"></span>
            <span class="mt-tune-name" [class.mt-tune-name--muted]="!option.value">{{ option.key }}</span>
          </div>
          <button
            type="button"
            class="mt-switch"
            [class.mt-switch--on]="option.value"
            [disabled]="checkValidityOfOptions(option)"
            (click)="setOptionToActive(option)"
            [attr.aria-pressed]="option.value"
          >
            <span class="mt-switch-knob"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="mt-tuning-group" *ngIf="otherItems().length">
      <div class="mt-tuning-head mt-tuning-head--other">
        <span class="mt-tuning-ico" aria-hidden="true">
          <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#8AF0A8" stroke-width="3" stroke-linecap="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </span>
        <span class="mt-tuning-label mt-tuning-label--green">OTHER TUNINGS</span>
        <span class="mt-tuning-meta" *ngIf="otherItems().length">{{ otherItems().length }} options</span>
        <span class="mt-tuning-rule mt-tuning-rule--green"></span>
        <span class="mt-scroll-hint" *ngIf="scrollOtherSection">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#5B5D74" stroke-width="2.5">
            <polyline points="6 9 12 15 18 9" />
          </svg>
          SCROLL
        </span>
      </div>
      <div class="mt-tuning-grid" [class.mt-tuning-grid--scroll]="scrollOtherSection">
        <div
          *ngFor="let option of otherItems()"
          class="mt-tune-row"
          [class.mt-tune-row--on]="option.value"
        >
          <span class="mt-tune-name" [class.mt-tune-name--muted]="!option.value">{{ option.key }}</span>
          <button
            type="button"
            class="mt-switch"
            [class.mt-switch--on]="option.value"
            [disabled]="checkValidityOfOptions(option)"
            (click)="setOptionToActive(option)"
            [attr.aria-pressed]="option.value"
          >
            <span class="mt-switch-knob"></span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <footer class="mt-tuning-footer" [class.mt-tuning-footer--amber]="unidentified">
    <span class="mt-footer-hint">{{ footerSummary() }}</span>
    <button
      type="button"
      class="mt-request-btn"
      (click)="requestFileTune(stockFileDTO.stockFileBlobName)"
      [disabled]="requestDisabled()"
    >
      Request Tune
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="12 5 19 12 12 19" />
      </svg>
    </button>
  </footer>
</ng-container>

<ng-container *ngIf="!paperLayout">
  <div class="available-options-container">
    <span class="title-list">Available Tunings</span>
    <div class="selected-options-wrapper">
      <div *ngFor="let option of selectedOptions; let i = index" class="selected-options">
        <span class="option-text">{{ option.key }}</span>
        <label class="switch" [for]="option.key + '-legacy'">
          <input
            type="checkbox"
            (click)="setOptionToActive(option)"
            [value]="option.key"
            [checked]="option.value"
            [id]="option.key + '-legacy'"
            [disabled]="checkValidityOfOptions(option)"
          />
          <div class="slider round"></div>
        </label>
      </div>
    </div>
    <div class="action-button" *ngIf="ecuBuildNameControl">
      <button
        (click)="requestFileTune(stockFileDTO.stockFileBlobName)"
        [disabled]="ecuBuildNameControl.hasError('required') || anyOptionsSelected()"
        class="button"
      >
        Request Tune
      </button>
    </div>

    <div class="action-button" *ngIf="!ecuBuildNameControl">
      <button (click)="requestFileTune(stockFileDTO.stockFileBlobName)" [disabled]="anyOptionsSelected()" class="button">
        Request Tune
      </button>
    </div>
  </div>
</ng-container>
